<template>
  <router-link 
    v-if="!isExternalLink"
    class="button"
    :to="link"
    :style="{background: bg, color: color}">
      <icono
        class="button__icon" 
        :icon="icono" 
        :size="20"
        ></icono>
      <span class="button__action">
        {{ action }}
      </span>
  </router-link>
  <a
    v-else
    class="button"
    :href="externalUrl"
    target="_blank"
    :style="{background: bg, color: color}">
      <icono
        class="button__icon" 
        :icon="icono" 
        :size="20"
        ></icono>
      <span class="button__action">
        {{ action }}
      </span>
  </a>
</template>

<script>
  export default {
    name: 'VButtonMain',
    props: {
      icono: String,
      link: Object,
      action: String,
      bg: String,
      color: String,
      isExternalLink: {
        type: Boolean,
        default: false
      },
      externalUrl: {
        type: String,
        default: '#'
      },
    }
  }
</script>

<style lang="scss" scoped>
  .button {
    padding: 5px 20px;
    margin: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    font-size: 14px;
    width: 150px;
    text-decoration: none;
    font-family: $color-white;
    &__action {
      margin-left: 10px;
    }
  }
</style>